import { Location } from '@angular/common';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StateStorageService } from '@df/browser/storage/state-storage.service';
import { PwaIntegrationService } from '@df/module-pwa/pwa-integration.service';
import { Customer } from '@df/session/api/customer';

export const signInAccessPrevUrlStorageKey = 'signInAccessPrevUrl';

export const urlsWithNeededAccess = ['/community', '/account'];

export const pwaCustomerLoggedGuard: CanActivateFn = async (route, state) => {
    const router = inject(Router);
    const customer = inject(Customer);
    const location = inject(Location);
    const pwaIntegrationService = inject(PwaIntegrationService);
    const stateStorageService = inject(StateStorageService);
    // Only apply this guard in standalone PWA mode
    if (!pwaIntegrationService.isStandalone) {
        return true;
    }

    try {
        await customer.model.load();

        // If user is logged in, allow access
        if (customer.model.isLoggedIn) {
            return true;
        }

        // Get the previous URL from browser history
        const previousUrl = location.path();

        const fromAccount = route.routeConfig?.path?.includes('account') ? true : false;
        // Validate prev url
        const returnPrevUrl =
            previousUrl && ![...urlsWithNeededAccess, '/sign-in-access'].find(url => previousUrl.includes(url)) ? previousUrl : undefined;
        await router.navigateByUrl(fromAccount ? '/sign-in-access?from=account' : '/sign-in-access');
        // Set up the previous URL after navigation cause its cleared after
        if (returnPrevUrl) {
            stateStorageService.set(signInAccessPrevUrlStorageKey, returnPrevUrl, true);
        }

        return false;
    } catch (error) {
        console.error('Error checking authentication status:', error);
        return false;
    }
};
